// import PackageRequestMain from "../../../../features/customer/package-request/components/package-request-main";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";
import CustomerDiscountMain from "../../../../features/customer/customer-discount/components/customer-discount-main";

const title = "Customer Discount";

const CustomerDiscountPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <CustomerDiscountMain />;
  // return "Customer Voucher Page";
};

export default CustomerDiscountPage;
